//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObject.js";
let d=[[[0,"UserDefinedSymbolAspectRatio",1,0],[0,"UserDefinedSymbolHeight",1,0],[0,"UserDefinedSymbolLength",1,0],[0,"UserDefinedSymbolScale",1,0],[0,"UserDefinedSymbolSizeMethod",1,0]],[[["numLines"],"GetAbove",{R_:{lines:""}},0,0],[["lines"],"SetAbove",{},1,0],[["numLines"],"GetAfter",{R_:{lines:""}},0,0],[["lines"],"SetAfter",{},1,0],[["numLines"],"GetBelow",{R_:{lines:""}},0,0],[["lines"],"SetBelow",{},1,0],[["numLines"],"GetBefore",{R_:{lines:""}},0,0],[["lines"],"SetBefore",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Annotations.AppendedTextBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.AppendedTextBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;